export const SET_ACHIEVEMENTS = 'achievements/SET_ACHIEVEMENTS';
export const SET_USER_ACHIEVEMENTS = 'achievements/SET_USER_ACHIEVEMENTS';
export const LOADING = 'achievements/LOADING';
